import { PdfiumExports as E, type PdfiumApi } from "@pdfking/pdfium-wrap"

import type { ReadDocumentResult } from "./ReadDocument"

export const CloseDocument = async (
  api: PdfiumApi,
  result: ReadDocumentResult
): Promise<void> => {
  if (result.doc_pointer) {
    await api.call(E.FPDF_CloseDocument, result.doc_pointer)
  }
  for (const func of result.cleanup_functions || []) {
    func()
  }
  result.blob_array.clear()
}
